import { gcDepartureId } from "@wojo/auth";
import { Card, Text } from "@wojo/ui";
import { forwardRef, Suspense, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { MicrositePageContentFragment } from "../../../generated/graphql";
import { TripBuilderContextProvider } from "./context/TripBuilderContext";
import { TripBuilderLoadingQuote } from "./trip-builder-quote-step/LoadingQuote";
import { TripBuilderMessageViewUnavailable } from "./message-views/TripBuilderMessageViewUnavailable";
import { TripBuilderQuoteStep } from "./trip-builder-quote-step/TripBuilderQuoteStep";
import { TripBuilderMessageViewWaitlist } from "./message-views/TripBuilderMessageViewWaitlist";
import { TripBuilderMessageViewCallToBook } from "./message-views/TripBuilderMessageViewCallToBook";
import { TripBuilderDeparturesStep } from "./trip-builder-departure-step/TripBuilderDeparturesStep";
import { TripBuilderMessageViewMarketing } from "./message-views/TripBuilderMessageViewMarketing";

export type TripBuilderProps = {
    gcDeparture?: MicrositePageContentFragment["gcDeparture"];
};

export const TripBuilder = forwardRef<HTMLDivElement, TripBuilderProps>(
    ({ gcDeparture }, ref) => {
        useEffect(() => {
            if (gcDeparture) {
                gcDepartureId(gcDeparture._id);
            }
        }, [gcDeparture]);

        return (
            <Card
                style={{
                    padding: 0,
                    marginTop: "var(--g-spacing-xl)",
                    marginBottom: "var(--g-spacing-xl)",
                    alignSelf: "flex-start",
                    overflow: "hidden",
                }}
                ref={ref}
                id="tripbuilder"
                tabIndex={-1}
            >
                <ErrorBoundary
                    fallback={
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "600px",
                            }}
                        >
                            <Text.Body>
                                Something went wrong. Departures not loaded.
                            </Text.Body>
                        </div>
                    }
                >
                    <Suspense fallback={<TripBuilderLoadingQuote />}>
                        <TripBuilderContextProvider gcDeparture={gcDeparture}>
                            <TripBuilderQuoteStep />
                            <TripBuilderDeparturesStep />
                            <TripBuilderMessageViewCallToBook />
                            <TripBuilderMessageViewWaitlist />
                            <TripBuilderMessageViewUnavailable />
                            <TripBuilderMessageViewMarketing />
                        </TripBuilderContextProvider>
                    </Suspense>
                </ErrorBoundary>
            </Card>
        );
    },
);

TripBuilder.displayName = "TripBuilder";
